var map = {
	"./IslasMarias.webp": 40192,
	"./islasmarias2.webp": 71440,
	"./islasmarias3.webp": 81408,
	"./islasmarias4.webp": 53800,
	"./islasmarias5.webp": 36904,
	"./islasmarias6.webp": 96448,
	"./islasmarias7.webp": 84528,
	"./islasmarias8.webp": 29854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51495;